export const MAP_DEFAULT_ZOOM = 5;
export const MAP_USER_ZOOM = 12;
export const MAP_SWEDEN_CENTER = [62, 15];

export const CONTACT_EMAIL = "info@lokalaparlor.com";